import React from 'react';
import ReactDOM from 'react-dom';

import { CentralHub } from './CentralHub';
import { initializeI18n } from '../../services/i18n-service';
import { Domain, findSiteByDomain, Locale, SiteProvider } from '@zooplus/commons-lang';
import { I18nextProvider } from 'react-i18next';
import SentryErrorBoundary from '../SentryErrorBoundary';
import FallbackComponent from '../ErrorFallback';
import { CartProvider } from '@zooplus/cart-provider';
import { ENV } from '../../environment';
import { AutoshipmentSiteProvider } from '../../common/contexts/AutoshipmentSiteContext';

const wrapper = document.getElementById('autoshipment-central-hub-wrapper') as HTMLElement;
if (wrapper) {
  const locale = (wrapper.getAttribute('data-locale')! ?? '').replace('_', '-') as Locale;
  const siteDomain = (wrapper.getAttribute('data-site-domain') ?? '') as Domain;
  renderCentralHub(wrapper, siteDomain, locale);
}

function renderCentralHub(element: HTMLElement, siteDomain: Domain, locale: Locale) {
  const site = findSiteByDomain(siteDomain);
  ReactDOM.render(
    <React.StrictMode>
      <SentryErrorBoundary FallbackComponent={FallbackComponent}>
        <I18nextProvider i18n={initializeI18n(locale)}>
          <SiteProvider locale={locale} site={site}>
            <AutoshipmentSiteProvider>
              <CartProvider stage={ENV.stage}>
                <CentralHub />
              </CartProvider>
            </AutoshipmentSiteProvider>
          </SiteProvider>
        </I18nextProvider>
      </SentryErrorBoundary>
    </React.StrictMode>,
    element,
  );
}
